"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EventsHandler_1 = __importDefault(require("./EventsHandler"));
exports.default = EventsHandler_1.default;
